import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";
import InputField from "../../components/common/InputField";
import PhoneInputField from "../../components/common/PhoneInputField";
import styles from "./styles/TicketBookingPage.module.scss";

const TicketBookingPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // Number of adult and child
  const [adult, setAdult] = useState(1);
  const [child, setChild] = useState(0);

  const [selectedCountryCode, setSelectedCountryCode] = useState("Nation");

  const countryOptions = [
    { code: "Nation", name: "Nation" },
    { code: "+84", name: "Vietnam" },
    { code: "+1", name: "United States" },
    { code: "+44", name: "United Kingdom" },
    { code: "+91", name: "India" },
    // Add other countries as needed
  ];

  const handleAdultIncrement = () => {
    setAdult(adult + 1);
  };

  const handleAdultDecrement = () => {
    if (adult > 0) {
      setAdult(adult - 1);
    }
  };

  const handleChildIncrement = () => {
    setChild(child + 1);
  };

  const handleChildDecrement = () => {
    if (child > 0) {
      setChild(child - 1);
    }
  };

  return (
    <div className={styles.ticketBookingPage}>
      {/* Left Section */}
      <div className={styles.leftSection}>
        <p className="mb-4 text-[1.875rem] font-semibold leading-[40pzx]">
          {t("Ticket booking")}
        </p>
        <div className={styles.contentWrapper}>
          <div className={styles.ticketCard}>
            <div className={styles.ticketImage}>
              <img
                src="https://s3-alpha-sig.figma.com/img/7493/9155/fbd94c817e009f61a0db77c0cca836c8?Expires=1732492800&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=ivK2lsBbhcQ9q0iZHp4tFAT4aSKvxgBE5Jf7aowSxR3OjEYEgY5VxV3jm9Ancy~6k20swEHzoJUwLMBN6yK14IsbCoZsi3CeAJmBAe6ClwguAUTmxQOzdV116cH2tGqGncADPxn2BfHf3MNdz6i0UHex27VbvZAKNSXITiR15QagyWWkSf0Jz72XtsF8JxA2RQQ427EGIrrORvzfr1NrYYXkrDw9cFcOgybanR9yq69aYIAqA-vRp4wDbkrAPpK1ckamsBt8agQNGVJZZ98Eley6iTqXJcPvFWRRb0s6vcR03PMLlUmirN86-8GQBkhpWjbqIaoH9Cpi0NWL1WVn4Q__"
                alt="new york"
              />
            </div>

            <div className={styles.ticketInfo}>
              <p className={styles.ticketTitle}>
                Top of the Rock Observation Ticket in New York
              </p>
              <div className={styles.ticketLocation}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 9C7.50555 9 7.0222 8.85338 6.61108 8.57868C6.19995 8.30397 5.87952 7.91353 5.6903 7.45671C5.50108 6.99989 5.45157 6.49723 5.54804 6.01228C5.6445 5.52732 5.8826 5.08187 6.23223 4.73223C6.58187 4.3826 7.02732 4.1445 7.51228 4.04804C7.99723 3.95157 8.4999 4.00108 8.95671 4.1903C9.41353 4.37952 9.80397 4.69995 10.0787 5.11108C10.3534 5.5222 10.5 6.00555 10.5 6.5C10.4992 7.1628 10.2356 7.79822 9.76689 8.26689C9.29822 8.73556 8.6628 8.99921 8 9ZM8 5C7.70333 5 7.41332 5.08797 7.16665 5.2528C6.91997 5.41762 6.72771 5.65189 6.61418 5.92598C6.50065 6.20007 6.47095 6.50167 6.52882 6.79264C6.5867 7.08361 6.72956 7.35088 6.93934 7.56066C7.14912 7.77044 7.41639 7.9133 7.70737 7.97118C7.99834 8.02906 8.29994 7.99935 8.57403 7.88582C8.84812 7.77229 9.08238 7.58003 9.24721 7.33336C9.41203 7.08668 9.5 6.79667 9.5 6.5C9.4996 6.1023 9.34144 5.721 9.06022 5.43978C8.779 5.15856 8.3977 5.0004 8 5Z"
                    fill="#5E6D77"
                  />
                  <path
                    d="M8 15L3.782 10.0255C3.72339 9.95081 3.66539 9.87564 3.608 9.8C2.88786 8.8507 2.49866 7.69155 2.5 6.5C2.5 5.04131 3.07947 3.64236 4.11092 2.61091C5.14237 1.57946 6.54131 1 8 1C9.45869 1 10.8576 1.57946 11.8891 2.61091C12.9205 3.64236 13.5 5.04131 13.5 6.5C13.5012 7.69098 13.1122 8.84954 12.3925 9.7985L12.392 9.8C12.392 9.8 12.242 9.997 12.2195 10.0235L8 15ZM4.4065 9.1975C4.4065 9.1975 4.523 9.3515 4.5495 9.3845L8 13.454L11.455 9.379C11.477 9.3515 11.594 9.1965 11.5945 9.196C12.1831 8.42057 12.5012 7.47352 12.5 6.5C12.5 5.30653 12.0259 4.16193 11.182 3.31802C10.3381 2.47411 9.19348 2 8 2C6.80653 2 5.66194 2.47411 4.81802 3.31802C3.97411 4.16193 3.5 5.30653 3.5 6.5C3.49877 7.47415 3.81723 8.42179 4.4065 9.1975Z"
                    fill="#5E6D77"
                  />
                </svg>
                <p className={styles.ticketLocationText}>New York, USA</p>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className={styles.divider}></div>

          {/* Booking info: date & time, location, adult, child */}
          <p className={styles.bookingInfoTitle}>{t("Your Booking")}</p>

          <div className={styles.bookingInfoContainer}>
            <div className={styles.bookingInfoItem}>
              <p className={styles.label}>{t("Date and time")}</p>
              <p className={styles.label}>10/10/2024, 10:10 AM</p>
            </div>
            <div className={styles.bookingInfoItem}>
              <p className={styles.label}>{t("Location")}</p>
              <p className={styles.label}>NewYork 123, England</p>
            </div>
            <div className={styles.bookingInfoItem}>
              <p className={styles.label}>{t("Adult")}</p>
              <div className="flex flex-row items-center space-x-3">
                <button
                  className="flex h-[2.125rem] w-[2.125rem] items-center justify-center rounded-full border-[0.0625rem] border-[#5E6D77] bg-white text-black"
                  onClick={handleAdultDecrement}
                >
                  <svg
                    width="12"
                    height="2"
                    viewBox="0 0 12 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.02002 1.02539H11.02"
                      stroke="#5E6D77"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <p className="text-base font-normal leading-[1.25rem] text-[#232323]">
                  {adult}
                </p>
                <button
                  className="flex h-[2.125rem] w-[2.125rem] items-center justify-center rounded-full border-[0.0625rem] border-[#5E6D77] bg-white text-black"
                  onClick={handleAdultIncrement}
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.02002 6H11.02"
                      stroke="#5E6D77"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M6.02002 1V11"
                      stroke="#5E6D77"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div className={styles.bookingInfoItem}>
              <p className={styles.label}>{t("Child")}</p>
              <div className="flex flex-row items-center space-x-3">
                <button
                  className="flex h-[2.125rem] w-[2.125rem] items-center justify-center rounded-full border-[0.0625rem] border-[#5E6D77] bg-white text-black"
                  onClick={handleChildDecrement}
                >
                  <svg
                    width="12"
                    height="2"
                    viewBox="0 0 12 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.02002 1.02539H11.02"
                      stroke="#5E6D77"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <p className="text-base font-normal leading-[1.25rem] text-[#232323]">
                  {child}
                </p>
                <button
                  className="flex h-[2.125rem] w-[2.125rem] items-center justify-center rounded-full border-[0.0625rem] border-[#5E6D77] bg-white text-black"
                  onClick={handleChildIncrement}
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.02002 6H11.02"
                      stroke="#5E6D77"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M6.02002 1V11"
                      stroke="#5E6D77"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className={styles.divider}></div>

          <p className={styles.bookingInfoTitle}>{t("Promotion")}</p>
          <div className={styles.bookingInfoContainer}>
            <div className={styles.bookingInfoItem}>
              <p className={styles.label}>{t("Promote code")}</p>
              <div className="relative flex h-[3.125rem] w-[16.25rem] items-center">
                <input
                  type="text"
                  placeholder="Enter or select voucher"
                  className="h-full w-full rounded-[6.1875rem] border border-[#DCDCDC] p-4 text-[0.875rem] leading-[1.25rem] text-[#5E6D77]"
                />
                <button className="absolute right-2 rounded-[6.1875rem] bg-[#DBE7FF] px-4 py-3 text-[0.875rem] font-semibold leading-[0.625rem] text-[#007AFF]">
                  {t("Apply")}
                </button>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className={styles.divider}></div>

          <p className={styles.bookingInfoTitle}>{t("Price Detail")}</p>
          <div className={styles.bookingInfoContainer}>
            <div className={styles.bookingInfoItem}>
              <p className={styles.label}>{t("Price")}</p>
              <div className="flex flex-col items-end justify-center">
                <p className="text-base font-normal leading-[1.625rem] text-[#232323]">
                  $250 x 2 adults
                </p>
                <p className="text-base font-normal leading-[1.625rem] text-[#232323]">
                  $100 x 1 child
                </p>
              </div>
            </div>
            <div className={styles.bookingInfoItem}>
              <p className={styles.label}>{t("VAT & Service charge")}</p>
              <p className="text-base font-normal leading-[1.625rem] text-[#232323]">
                $0
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className={styles.divider}></div>

          <p className={styles.bookingInfoTitle}>
            {t("Credit card information")}
          </p>

          <div className={styles.bookingInfoContainer}>
            <div className="relative flex h-[3.125rem] w-full items-center">
              <input
                type="text"
                placeholder="Card number"
                className="h-full w-full rounded-[6.1875rem] border border-[#DCDCDC] p-4 text-[0.875rem] leading-[1.25rem] text-[#5E6D77]"
              />
              <svg
                className="absolute right-4"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 8.50586H22"
                  stroke="#5E6D77"
                  strokeWidth="1.5"
                  stroke-miterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 16.5059H8"
                  stroke="#5E6D77"
                  strokeWidth="1.5"
                  stroke-miterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10.5 16.5059H14.5"
                  stroke="#5E6D77"
                  strokeWidth="1.5"
                  stroke-miterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.44 3.50586H17.55C21.11 3.50586 22 4.38586 22 7.89586V16.1059C22 19.6159 21.11 20.4959 17.56 20.4959H6.44C2.89 20.5059 2 19.6259 2 16.1159V7.89586C2 4.38586 2.89 3.50586 6.44 3.50586Z"
                  stroke="#5E6D77"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="flex flex-row gap-2">
              <div className="relative flex h-[3.125rem] w-full items-center">
                <input
                  type="text"
                  placeholder="Expiration date (MM/YY)"
                  className="h-full w-full rounded-[6.1875rem] border border-[#DCDCDC] p-4 text-[0.875rem] leading-[1.25rem] text-[#5E6D77]"
                />
              </div>
              <div className="relative flex h-[3.125rem] w-full items-center">
                <input
                  type="text"
                  placeholder="CVV"
                  className="h-full w-full rounded-[6.1875rem] border border-[#DCDCDC] p-4 text-[0.875rem] leading-[1.25rem] text-[#5E6D77]"
                />
              </div>
            </div>
            <div className="relative flex h-[3.125rem] w-full items-center">
              <input
                type="text"
                placeholder="Name on card"
                className="h-full w-full rounded-[6.1875rem] border border-[#DCDCDC] p-4 text-[0.875rem] leading-[1.25rem] text-[#5E6D77]"
              />
            </div>
          </div>

          {/* Divider */}
          <div className={styles.divider}></div>

          <div className="mb-8 flex flex-row justify-between">
            <p className="text-[1.125rem] font-semibold leading-[1.5625rem] text-[#232323]">
              {t("Pay amount")}
            </p>
            <p className="text-[1.125rem] font-semibold leading-[1.5625rem] text-[#232323]">
              $600
            </p>
          </div>

          <button
            className="h-[3.125rem] w-full rounded-[6.1875rem] bg-[#BFC5C9] text-base font-semibold leading-[1.25rem] text-white"
            onClick={() => navigate("/ticket/booking-success")}
          >
            {t("Book")}
          </button>
        </div>
      </div>

      {/* Right Section */}
      <div className="ml-10 flex-1 rounded-[1.25rem] bg-white">
        <p className="mb-2 text-[1.875rem] font-semibold leading-[2.5rem]">
          {t("Information")}
        </p>
        <p className="mb-10 text-base font-normal leading-[1.625rem]">
          {t("Enter the representative customer info when booking")}
        </p>

        {/* Label and Input Field */}
        <div className="flex w-full flex-row gap-[1.875rem]">
          <InputField
            label={t("Last name")}
            placeholder={t("Please enter your last name")}
            required={true}
            value=""
            onChange={(e) => console.log(e.target.value)}
          />
          <InputField
            label={t("First name")}
            placeholder={t("Please enter your first name")}
            required={true}
            value=""
            onChange={(e) => console.log(e.target.value)}
          />
        </div>
        <div className="flex w-full flex-row gap-[1.875rem]">
          <InputField
            label={t("Korean name")}
            placeholder={t("Please enter your last name")}
            required={false}
            value=""
            onChange={(e) => console.log(e.target.value)}
          />
        </div>
        <div className="flex w-full flex-row gap-[1.875rem]">
          <InputField
            className="w-[21.25rem]"
            label={t("Email")}
            placeholder={t("Please enter your email")}
            required={true}
            value=""
            onChange={(e) => console.log(e.target.value)}
          />

          <PhoneInputField
            className="w-full"
            label={t("Phone number")}
            placeholder={t("Please enter phone number")}
            required={true}
            value=""
            onChange={(e) => console.log(e.target.value)}
            countryOptions={countryOptions}
            selectedCountryCode={selectedCountryCode}
            onCountryChange={(e) => setSelectedCountryCode(e.target.value)}
          />
        </div>
        <InputField
          label={t("Address (optional)")}
          placeholder={t("Please enter your address")}
          required={false}
          value=""
          onChange={(e) => console.log(e.target.value)}
        />
        <div className="mt-10">
          <span className="text-[1.375rem] font-semibold leading-[1.125rem] text-[#232323]">
            {t("Requirement")}{" "}
            <span className="text-center text-base leading-[1.125rem]">
              ({t("optional")})
            </span>
          </span>
          <p className="text-base font-normal leading-[1.625rem] text-[#232323]">
            {t("The request may not be accommodated depending on the service")}
          </p>
          <textarea
            placeholder={t("Please enter your request")}
            className="mt-4 h-[8.75rem] w-full rounded-[0.625rem] border border-[#DCDCDC] p-3 text-base font-normal leading-[1.375rem] text-[#5E6D77]"
            onChange={(e) => console.log(e.target.value)}
          />
        </div>
        <div className="mt-10">
          <span className="text-[1.375rem] font-semibold leading-[1.125rem] text-[#232323]">
            {t("Policy")}
          </span>
          {/*  Add a group of check box */}
          <div className="mt-4 rounded-[0.625rem] border border-[#DCDCDC] px-5 py-[1.875rem]">
            <div className="flex flex-col gap-4">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  className="mr-2 h-5 w-5 border border-[#DCDCDC]"
                />
                <span className="text-[0.875rem] font-normal leading-[1.25rem] text-[#232323]">
                  {t("Agree all")}
                </span>
              </div>
              <div className="flex items-center">
                <input type="checkbox" className="mr-2 h-5 w-5" />
                <span className="text-[0.875rem] font-normal leading-[1.25rem] text-[#232323]">
                  개인정보 수집 및 이용동의 (필수)
                </span>
              </div>
              <div className="flex items-center">
                <input type="checkbox" className="mr-2 h-5 w-5" />
                <span className="text-[0.875rem] font-normal leading-[1.25rem] text-[#232323]">
                  개인정보 제 3자 제공 동의 (필수)
                </span>
              </div>
              <div className="flex items-center">
                <input type="checkbox" className="mr-2 h-5 w-5" />
                <span className="text-[0.875rem] font-normal leading-[1.25rem] text-[#232323]">
                  개인정보 해외이전 동의 (필수)
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="mt-10 flex items-center">
          <input type="checkbox" className="mr-2 h-5 w-5" />
          <span className="text-[0.875rem] font-normal leading-[1.25rem] text-[#232323]">
            {t("Save this billing address")}
          </span>
        </div> */}
      </div>
    </div>
  );
};

export default TicketBookingPage;
